// SPDX-License-Identifier: AGPL-3.0-or-later

import {TimestampWithTooltip} from '@app/features/channel/components/TimestampWithTooltip';
import styles from '@app/features/theme/styles/Message.module.css';
import {PencilSimpleIcon} from '@app/features/ui/icons/Icons';
import {msg} from '@lingui/core/macro';
import {useLingui} from '@lingui/react/macro';

const EDITED_DESCRIPTOR = msg({
	message: 'Edited',
	comment: 'Accessible label for the pencil icon marking an edited message.',
});

interface MessageEditedIndicatorProps {
	readonly date?: Date | null;
}

export function MessageEditedIndicator({date}: MessageEditedIndicatorProps) {
	const {i18n} = useLingui();
	const icon = (
		<PencilSimpleIcon
			size={12}
			className={styles.editedLabel}
			aria-label={i18n._(EDITED_DESCRIPTOR)}
			data-flx="channel.message-edited-indicator.icon"
		/>
	);

	if (!date) {
		return (
			<span className={styles.editedTimestamp} data-flx="channel.message-edited-indicator.container">
				{icon}
			</span>
		);
	}

	return (
		<TimestampWithTooltip date={date} className={styles.editedTimestamp}>
			{icon}
		</TimestampWithTooltip>
	);
}
